import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDwv-M5Y53OarWQRGW0TeQJpgwfMenxzs4",
  authDomain: "soignant-demo.firebaseapp.com",
  projectId: "soignant-demo",
  storageBucket: "soignant-demo.appspot.com",
  messagingSenderId: "254374478554",
  appId: "1:254374478554:web:138e886e38c1bce2275be3",
  measurementId: "G-PZZJ2SN882"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
